/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Artifact_Canvas_Custom_DomainInputs */



/**
* | output |
* | --- |
* | "Custom domain…" |
*
* @param {Artifact_Canvas_Custom_DomainInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const artifact_canvas_custom_domain = /** @type {((inputs?: Artifact_Canvas_Custom_DomainInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Artifact_Canvas_Custom_DomainInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Eigene Domain…")
	return /** @type {LocalizedString} */ ("Custom domain…")
});